exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-table-row[data-v-44b177d0]{padding:6px 0;border-bottom:1px solid #989898}.lp-menu-div[data-v-44b177d0]{margin-bottom:8px}.lp-table-row:hover .add-category[data-v-44b177d0]{display:block}.add-category[data-v-44b177d0]{display:none;position:absolute;bottom:-14px;-webkit-transform:translate(-50%);transform:translate(-50%);background-color:#eee;padding:4px 8px;border-radius:8px;z-index:10}.lp-box[data-v-44b177d0]{margin-top:12px}.lp-box[data-v-44b177d0]:first-child{margin-top:0}", ""]);

// exports
